import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import { Message } from 'element-ui'
import store from '@/store'
import VueCookies from 'vue-cookies'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/home/index'], resolve),
		    meta:{
			    per:""
		    }
      }
    ]
  }]
const router = new VueRouter({
  routes,
  mode:"history"
})
router.beforeEach((to, form, next) => {
  next()
	// if (VueCookies.get('carwebToken')) {
	// 	next()
	// } else {
	// 	if (to.path == '/login') {
	// 		next()
	// 	} else {
	// 		Message.error('请登录后进行操作')
	// 		next('/login')
	// 	}
	// }
})
export default router